import { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import ResourcePage from "@/components/common/ResourcePage";
import { EntityFormDialog } from "@/components/common/EntityFormDialog";
import { PageHeader } from "@/components/common/States";
import { DocumentsDialog } from "@/components/crm/DocumentsDialog";
import { AiDraftDialog, mergeDraft } from "@/components/crm/AiDraftDialog";
import { useWorkspace } from "@/context/WorkspaceContext";
import { products } from "@/lib/resources";

export default function Products() {
  const { api, can } = useWorkspace();
  const [docsFor, setDocsFor] = useState(null);
  const [aiFor, setAiFor] = useState(null);
  const [review, setReview] = useState(null);
  const [pendingDocs, setPendingDocs] = useState([]);
  const [reloadKey, setReloadKey] = useState(0);

  const save = async (payload) => {
    if (review.id) await api.patch(`/product-profiles/${review.id}`, payload);
    else {
      const { data } = await api.post("/product-profiles", payload);
      if (pendingDocs.length) await api.post("/documents/link", { document_ids: pendingDocs, product_profile_id: data.id });
    }
    toast.success(review.id ? "Product profile updated" : "Product profile created");
    setReview(null); setPendingDocs([]); setReloadKey((k) => k + 1);
  };

  return (
    <div data-testid="products-page">
      <PageHeader eyebrow="Knowledge" title="Product Knowledge Base"
        description="Product profiles guide research and qualification. External facts must still come from retrieved source evidence."
        actions={can("write") && <Button variant="outline" onClick={() => setAiFor({ product: null })} data-testid="ai-draft-new-button"><Sparkles className="mr-1.5 h-4 w-4 text-primary" />Draft with AI</Button>} />
      <ResourcePage config={products} reloadKey={reloadKey} extraRowActions={(row) => [
        { id: "documents", label: "Documents & case studies", onClick: () => setDocsFor(row) },
        ...(can("write") ? [{ id: "ai-draft", label: "Draft with AI", onClick: () => setAiFor({ product: row }) }] : []),
      ]} />
      <DocumentsDialog product={docsFor} onOpenChange={(o) => !o && setDocsFor(null)} />
      <AiDraftDialog open={Boolean(aiFor)} product={aiFor?.product} onOpenChange={(o) => !o && setAiFor(null)}
        onApply={(draft, docIds) => { setPendingDocs(docIds || []); setReview(mergeDraft(aiFor?.product, draft)); }} />
      <EntityFormDialog open={Boolean(review)} onOpenChange={(o) => { if (!o) { setReview(null); setPendingDocs([]); } }} title="Review AI draft before saving"
        fields={products.fields} record={review} onSubmit={save} testid="ai-review-form" />
    </div>
  );
}
